
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/people/new-professions",
      function () {
        return require("private-next-pages/csr/people/new-professions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/people/new-professions"])
      });
    }
  